import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DtoProductCostVM } from '../../../Model/cost-calculation/DtoProductCostVM';
import { CostCalculationService } from '../../../Services/cost-calculation.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../../Shared/Services/auth.service';
import { Router } from '@angular/router';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { UserType } from '../../../Shared/Enums/UserType';
import { DtoOrderInfoVM } from '../../../Model/cost-calculation/MakeSectorsOrder/DtoOrderInfoVM';
import { environment } from '../../../../environments/environment'
import { DownloadService } from '../../../Services/download.service';
import { DtoInvoiceToPdf } from '../../../Model/cost-calculation/MakeSectorsOrder/DtoInvoiceToPdf';
import { OrdersService } from '../../../Services/orders.service';
import { DtoInvoiceVM } from '../../../Model/orders/DtoInvoiceVM';
import { IngredientInfoVM } from '../../../Model/cost-calculation/MakeSectorsOrder/IngredientInfoVM';
import { UserInfoService } from '../../../Services/user-info.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DtoUserAndAgentVM } from '../../../Model/agents/DtoUserAndAgentVM';
import { SharedService } from '../../../Shared/Services/shared.service';
import { DialogService } from '../../../Shared/Services/dialog.service';
import { AddClientforOrderComponent } from '../add-client-for-order/add-client-for-order.component';
import { AccessoryInfoVM } from '../../../Model/cost-calculation/MakeSectorsOrder/AccessoryInfoVM';

@Component({
  selector: 'app-make-sectors-order',
  templateUrl: './make-sectors-order.component.html',
  styleUrl: './make-sectors-order.component.scss'
})
export class MakeSectorsOrderComponent {
  @Output() IsMakeSectorsOrder = new EventEmitter<boolean>();
  @Input() SectorsOrderData: DtoProductCostVM[] = [];
  @Input() SectorId: string | null = null;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  OrderInfoData: DtoOrderInfoVM = {};
  imgPath: string = environment.ImgUrl;
  totalOrderCost: number = 0;
  UserInfo: DtoUserAndAgentVM = {};
  invoicesNumber?: number = 0;
  invoicesDate?: Date;
  selectedClient?: string;

  constructor(private api: CostCalculationService, private download: DownloadService, private userService: UserInfoService,
    private spinner: NgxSpinnerService, private auth: AuthService, private orderService: OrdersService, private shared: SharedService,
    private router: Router, private toastrService: CustomToastrService, private dialogService: DialogService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Workshop])) {
      this.spinner.show();
      this.GetOrderInfo();
      this.GetAgentData();
      this.GetMaxNumberIncoices();
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetOrderInfo() {
    if (this.auth.isAuthenticated([UserType.Workshop])) {
      this.spinner.show();
      let data = {'sectorId': this.SectorId, 'products': this.SectorsOrderData};
      this.api.GetOrderInfo(data)
        .subscribe(
          {
            next: (data: any) => {
              this.spinner.hide();
              this.OrderInfoData = data;
              this.ClacTotalOrderCost();
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetMaxNumberIncoices() {
    this.orderService.GetMaxNumberIncoices()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          if (data.isSuccess) {
            this.invoicesNumber = data.payload;
          }
        },
        error: (error: any) => {
          this.toastrService.showErrorToast('Error', "SomethingWentWrong");
        }
      });
  }

  ClacTotalOrderCost() {
    this.totalOrderCost = 0;
    this?.OrderInfoData?.ingredientsInfo?.map((a: IngredientInfoVM) => {
      this.totalOrderCost += Number(a.totalByDescount!);
    });
  }

  Delete(productId?: number) {
    this.dialogService.confirmDialog({
      titleKey: 'confirmation',
      messageKey: 'AreYouSuretoDeleteThis',
      confirmTextKey: 'Yes',
      cancelTextKey: 'No'
    }).subscribe(isConfirmed => {
      if (isConfirmed) {
        this?.OrderInfoData?.ingredientsInfo?.map((a: IngredientInfoVM) => {
          if (a.product?.productId == productId) {
            this.OrderInfoData.ingredientsInfo = this?.OrderInfoData?.ingredientsInfo?.filter(item => item?.product?.productId !== productId);
          }
        });

        this.ClacTotalOrderCost();
      }
    });
  }

  GetDtoInvoiceToPdf(): DtoInvoiceToPdf {
    let data: DtoInvoiceToPdf = {
      totalWithInvoices: Math.round(this.totalOrderCost * 1e2) / 1e2,
      supplierName: this.UserInfo.name,
      supplierPhone: this.UserInfo.agentPhone,
      supplierGovernorate: this.UserInfo.agentGovernorate,
      supplierAddress: this.UserInfo.agentAddress,
      details: []
    };

    this?.OrderInfoData?.ingredientsInfo?.map((a: IngredientInfoVM) => {
      if(a.product?.tblProductName?.name?.includes('زجاج ')){

        data.details?.push({
          productId: a.product?.productId,
          color: a.product?.tblColors?.colorName,
          productName: a?.product?.tblProductName?.name,
          numberIron: 0,
          imgURL: a?.product?.tblProductName?.imgURL,
          quantity: 1,
          descount: a?.descount,
          pricePerOne: a?.product?.pricePerOne,
          priceWithDescount: a?.totalByDescount,
          pricePerMeter: 0,
          totalOrder:a?.product?.pricePerOne,
          perPack: false,
          haveIron: a?.product?.tblCategory?.tblParentProductCategory?.haveIron
        });
      }
      else{
          data.details?.push({
          productId: a.product?.productId,
          color: a.product?.tblColors?.colorName,
          productName: a?.product?.tblProductName?.name,
          numberIron: 0,
          imgURL: a?.product?.tblProductName?.imgURL,
          quantity: a?.numRollsUsed,
          descount: a?.descount,
          pricePerOne: a?.product?.pricePerOne,
          priceWithDescount: a?.totalByDescount,
          pricePerMeter: 0,
          totalOrder: Math.round(a?.totalByDescount! * 1e2) / 1e2,
          perPack: false,
          haveIron: a?.product?.tblCategory?.tblParentProductCategory?.haveIron
        });
      }
    });
    this?.OrderInfoData?.accessoriesInfo?.map((a: AccessoryInfoVM) => {
      data.details?.push({
        productId: a.product?.productId,
        color: a.product?.tblColors?.colorName,
        productName: a?.product?.tblProductName?.name,
        numberIron: 0,
        imgURL: a?.product?.tblProductName?.imgURL,
        quantity: a?.count,
        descount: a?.descount !== undefined ? Number(a.descount) : undefined,
        pricePerOne: a?.product?.pricePerOne,
        priceWithDescount: a?.totalByDescount !== undefined ? Number(a.totalByDescount) : undefined,
        pricePerMeter: 0,
        totalOrder: Math.round((a.count ?? 0) * (a.product?.pricePerOne ?? 0)) ,
        perPack: false,
        haveIron: a?.product?.tblCategory?.tblParentProductCategory?.haveIron
      });
    });
    return data;
  }

  GetAgentData() {
    this.userService.GetAgentInfo()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          if (data.isSuccess) {
            this.UserInfo = data.payload;
          }
        },
        error: (error: any) => {
          this.toastrService.showErrorToast('Error', "SomethingWentWrong");
        }
      });
  }

exportPDF() {
    if (this.auth.isAuthenticated([UserType.Workshop])) {
      this.spinner.show();
      // this.shared.exportPDF(this.OrderInfoData);
      this.spinner.hide();
      let data: DtoInvoiceToPdf = this.GetDtoInvoiceToPdf();
      this.download.InvoiceToPdf(data).subscribe({
        next: (data: any) => {
          this.spinner.hide();
          console.log(data);

          this.shared.downloadFile(data, 'invoice');
          // this.shared.exportPDF(data);
        },
        error: (error: any) => {
          this.spinner.hide();
          this.toastrService.showErrorToast('Error', 'SomethingWentWrong');
        },
      });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetDtoInvoiceVM(): DtoInvoiceVM {
    let data: DtoInvoiceVM = {
      invoicesNumber: this.invoicesNumber,
      isRecived: true,
      totalInvoices: this.totalOrderCost,
      descountInvoices: 0,
      totalWithInvoices: this.totalOrderCost,
      totalPayed: 0,
      totalAmount: 0,
      toUserId: this.selectedClient?.toString(),
      invoicesDate: this.invoicesDate
    };

    return data;
  }

  AddNewInvoices() {
    if (this.auth.isAuthenticated([UserType.Workshop])) {
      this.dialogService.confirmDialog({
        titleKey: 'confirmation',
        messageKey: 'AreYouSuretoSendOrder',
        confirmTextKey: 'Yes',
        cancelTextKey: 'No'
      }).subscribe(isConfirmed => {
        if (isConfirmed) {
          let dialogClientsList = this.dialogService.openDialog(AddClientforOrderComponent);

          dialogClientsList.afterClosed().subscribe(result => {
            if (result) {
              this.invoicesDate = result?.invoicesDate;
              this.selectedClient = result?.selectedClient;
              this.ConfirmAddNewInvoices();
            }
          });
        }
      });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  ConfirmAddNewInvoices() {
    if (this.auth.isAuthenticated([UserType.Workshop])) {
      this.spinner.show();
      let data: DtoInvoiceVM = this.GetDtoInvoiceVM();
      this.orderService.AddNewInvoices(data)
        .subscribe(
          {
            next: (data: any) => {
              this.spinner.hide();
              if (data.status == "success") {
                this.toastrService.showSuccessToast('Success', 'OrderSentSuccessfully');
                setTimeout(() => {  this.IsMakeSectorsOrder.emit(false); }, 600);
              } else {
                this.toastrService.showErrorToast('Error', data.message);
              }
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  DeleteOrder() {
    this.dialogService.confirmDialog({
      titleKey: 'confirmation',
      messageKey: 'AreYouSuretoDeleteOrder',
      confirmTextKey: 'Yes',
      cancelTextKey: 'No'
    }).subscribe(isConfirmed => {
      this.IsMakeSectorsOrder.emit(false);
    });
  }

  Cancel() {
    this.dialogService.confirmDialog({
      titleKey: 'confirmation',
      messageKey: 'AreYouSuretoBackWithoutSave',
      confirmTextKey: 'Yes',
      cancelTextKey: 'No'
    }).subscribe(isConfirmed => {
      if (isConfirmed) {
        this.IsMakeSectorsOrder.emit(false);
      }
    });
  }
}
